import { OutgoingMessageType } from 'messages/websocket.messages';

import { VideoRoomService } from '../services/video-room.service';

export class Track {
  private kind: string;

  public constructor(
    public track: MediaStreamTrack | null,
    public userId: string,
    public service: VideoRoomService,
  ) {
    this.kind = track?.kind ?? '';
  }

  public enable(notify: boolean): void {
    if (this.track) {
      this.track.enabled = true;
    }

    if (notify) {
      this.service.sendToAll({ t: OutgoingMessageType.E, type: 'on', kind: this.kind, userId: this.userId });
    }
  }

  public disable(notify: boolean): void {
    if (this.track) {
      this.track.enabled = false;
    }

    if (notify) {
      this.service.sendToAll({ t: OutgoingMessageType.E, type: 'off', kind: this.kind, userId: this.userId });
    }
  }
}
